export default class KdiagramCalculationResultData {
  constructor(
    fdmData,
    valuesTableData,
    lineParametersData,
    calculationInputData,
  ) {
    this.fdmData = fdmData;
    this.valuesTableData = valuesTableData;
    this.lineParametersData = lineParametersData;
    this.calculationInputData = calculationInputData;
  }

}
